import { ContainerInput } from "./styles"
import IconSearch from '../../assets/Headers/IconSearch.svg'
import { forwardRef } from "react"

export const InputSearch = forwardRef((rest,inputRef) => {
    return (
        <ContainerInput>
            <div className="wrapper">
                <img src={IconSearch} alt={'imagem de uma lupa'}/>
                <input 
                    ref={inputRef}
                    placeholder="Buscar"
                    {...rest}
                />
            </div>
        </ContainerInput>
    )
})